import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { MaterialModule } from "@app/material.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";

import { DurationInputControlModule } from "../duration-input-control/duration-input-control.module";
import { TimeEditPopoverModule } from "../time-edit-popover/time-edit-popover.module";
import { TimeRangeControlComponent } from "./time-range-control.component";

@NgModule({
	declarations: [TimeRangeControlComponent],
	imports: [
		CommonModule,
		TimeInputModule,
		TimeEditPopoverModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,

		DateFnsModule,
		SatPopoverModule,
		TranslateModule,
		CustomDirectivesModule,
		DurationInputControlModule,
	],
	exports: [TimeRangeControlComponent],
})
export class TimeRangeControlModule {}
